import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';
import { DmData, DmDataFactory, DmDataFactoryFromJS, IDmData } from '../../../entities/IDmData';

export interface IBaseNavigationItem {
	id: string;
	name: string;
	extension?: string;
	type: number;
	path?: string;
	fullPath?: string;
	secretKey: string;
}

export interface INavigationItem extends IBaseNavigationItem {
	baseItem?: IDmData;
}

export interface IReadonlyNavigationItem extends IBaseNavigationItem {
	baseItem?: DmData;
}

export type NavigationItem = ReadonlyRecord<IReadonlyNavigationItem>;

export const NavigationItemFactory = Record<IReadonlyNavigationItem>({
	extension: null,
	id: null,
	name: null,
	type: null,
	path: null,
	fullPath: null,
	secretKey: null,
	baseItem: DmDataFactory()
});

export const NavigationItemFactoryFromJS = function (data: INavigationItem) {
	return NavigationItemFactory({
		...data,
		baseItem: DmDataFactoryFromJS(data.baseItem)
	});
};
